var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"w-list"},[(!_vm.loaded)?_c('w-progress-circular',{attrs:{"small":""}}):_vm._e(),(_vm.loaded)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }